import moment from "moment";
import { useEffect, useRef } from "react";

export const programmaticDownload = async (filename: string, imgName: string) => {
    try {
        const image = await fetch(filename);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        const link = document.createElement('a');

        link.href = imageURL;
        link.download = imgName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        console.log(e);
    }
}

export const usePrevious = (value: any): any => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
export const getAge = (dateOfBirth: string | null) => {
    const age = moment().diff(moment(dateOfBirth, "MM-DD-YYYY"), "years")
    return isNaN(age) ? "" : age
}

export const formatDate = (date: string) => moment(moment(date, 'MMDDYY')).format('MM/DD/YYYY')

export const getAcronym = (str: string) => str.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '')

export const stringToColor = (string: string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}
